var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h2',{staticClass:"head boxed"},[_vm._v(_vm._s(_vm.$t('Состояние')))]),_c('vue-damage-v2'),_c('vue-technical'),_c('vue-paint'),_c('vue-abroad'),_c('vue-custom'),_c('vue-country-import-usa'),_c('vue-credit'),_c('vue-confiscated'),_c('vue-spare-parts'),_c('vue-seller-type'),_c('vue-country-import'),_c('vue-options')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }